export const API_CONFIG = {
  baseURL: process.env.NEXT_PUBLIC_API_URL || 'http://192.168.0.193:20991',
  // 'http://192.168.0.193:20991',
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json',
  },
};
